<template>
  <a
    :href="projectUrl"
    class="artist-project-item"
    :class="elClasses"
    :data-artist="project.artistIds[0]"
    :data-tags="projectTags"
    >
    <figure>
      <video data-lazy :data-src="videoUrl" autoplay muted playsinline loop preload="metadata" ref="item" v-if="hasVideo"></video>
      <img data-lazy :data-src="imageUrl" ref="item" v-if="!hasVideo">

      <figcaption class="project-overlay">
        <div class="project-overlay__title">{{ project.artists }}</div>
        <div class="project-overlay__subtitle">{{ project.title }}</div>
      </figcaption>
    </figure>
  </a>
</template>

<script>
export default {
  name: 'CoverPhoto',

  props: {
    project: {
      type: Object,
      default: () => {}
    },

    cover: {
      type: Object,
      default: () => {}
    },

    filteredArtist: {
      type: Number,
      default: null
    }
  },

  computed: {
    projectUrl() {
      if (this.filteredArtist) {
        return this.project.urls[this.filteredArtist]
      } else {
        return this.project.urls[this.project.artistIds[0]]
      }
    },

    projectTags() {
      return JSON.stringify(this.project.tags)
    },

    hasVideo() {
      return this.cover.video_url
    },

    videoUrl() {
      return this.cover.video_url
    },

    imageUrl() {
      return `/assets/${this.cover.url}`
    },

    elClasses() {
      const classes = []

      if (this.cover.is_double_width) {
        classes.push('width-2')
      }

      if (this.cover.is_double_height) {
        classes.push('height-2')
      }

      return classes.join(' ')
    }
  },

  mounted() {
    const delay = Math.random() / 2
    this.$refs.item.style.setProperty('--enter-delay', `${delay}s`)
  }
}
</script>
